import React from 'react';
import classNames from 'classnames';
import { HiOutlineArrowLeft } from 'react-icons/hi';

const SigfoxDetailDevice = ({
  deviceHistory,
  selectedDevice,
  onBackToDevices,
  loadingHistory,
  isDark
}) => {
  return (
    <div className="mb-6">
      <div className="flex items-center mb-4">
        <button
          onClick={onBackToDevices}
          className={classNames(
            "flex items-center mr-4 px-3 py-2 rounded-lg transition-colors",
            isDark 
              ? "bg-gray-700 hover:bg-gray-600 text-gray-300" 
              : "bg-gray-200 hover:bg-gray-300 text-gray-700"
          )}
        >
          <HiOutlineArrowLeft className="w-4 h-4 mr-2" />
          戻る
        </button>
        <h2 className={classNames(
          "text-xl font-bold"
        )}>
          {selectedDevice.customerName} - {selectedDevice.seriesName} - {selectedDevice.customData}
        </h2>
      </div>

      {loadingHistory ? (
        <div className="flex justify-center items-center h-32">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className={classNames(
            "min-w-full rounded-lg overflow-hidden",
            isDark 
              ? "bg-gray-800 shadow-lg" 
              : "bg-white shadow-xl border border-gray-200"
          )}>
            <thead className={classNames(
              "text-left",
              isDark ? "bg-gray-700 text-gray-300" : "bg-blue-50 text-blue-900 border-b border-blue-200"
            )}>
              <tr>
                <th className="px-6 py-3 font-semibold">タイムスタンプ</th>
                <th className="px-6 py-3 font-semibold">データ</th>
                <th className="px-6 py-3 font-semibold">シーケンス</th>
                <th className="px-6 py-3 font-semibold">LQI</th>
                <th className="px-6 py-3 font-semibold">緯度</th>
                <th className="px-6 py-3 font-semibold">経度</th>
                <th className="px-6 py-3 font-semibold">半径</th>
                <th className="px-6 py-3 font-semibold">オペレーター</th>
              </tr>
            </thead>
            <tbody className={classNames(
              "divide-y",
              isDark ? "divide-gray-700" : "divide-blue-100"
            )}>
              {deviceHistory.map((record, index) => (
                <tr key={index} className={classNames(
                  "hover:bg-blue-50 dark:hover:bg-gray-700 transition-colors",
                  index % 2 === 0 
                    ? (isDark ? "bg-gray-800" : "bg-white") 
                    : (isDark ? "bg-gray-750" : "bg-blue-25")
                )}>
                  <td className="px-6 py-4 text-gray-600 dark:text-gray-400">
                    {record.timestamp ? new Date(record.timestamp).toLocaleString('ja-JP') : '-'}
                  </td>
                  <td className="px-6 py-4">
                    <div className="font-mono text-xs text-gray-500 dark:text-gray-400 max-w-xs truncate" title={record.dataPayload || '-'}>
                      {record.dataPayload || '-'}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-gray-600 dark:text-gray-400">
                    {record.seqNumber || '-'}
                  </td>
                  <td className="px-6 py-4 text-gray-600 dark:text-gray-400">
                    {record.lqi || '-'}
                  </td>
                  <td className="px-6 py-4 text-gray-600 dark:text-gray-400">
                    {record.computedLat || '-'}
                  </td>
                  <td className="px-6 py-4 text-gray-600 dark:text-gray-400">
                    {record.computedLng || '-'}
                  </td>
                  <td className="px-6 py-4 text-gray-600 dark:text-gray-400">
                    {record.computedRadius || '-'}
                  </td>
                  <td className="px-6 py-4 text-gray-600 dark:text-gray-400">
                    {record.operatorName || '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SigfoxDetailDevice; 